<template>
  <div class="flex items-center gap-2 my-3">
    <template v-if="itemsAddedToBuy">
      <product v-for="buy in itemsAddedToBuy" :key="buy" :buy="!!buy" :data="buy"/>
      <empty v-for="buy in itemsNotAddedToBuy" :key="buy" buy/>
      <niceone-image :src="$publicPath('/images/product/plus.svg')" class="min-w-4"/>
      <empty v-for="get in itemsNotAddedToGet" :key="get" :data="get"/>
    </template>
    <template v-if="isAllAddedToBuy">
      <product v-for="get in itemsAddedToGet" :key="get" :data="get"/>
      <div
          class="min-h-14 min-w-[0.125rem] rounded-md bg-light-grey ml-3 mr-4 rtl:mr-2 rtl:ml-4 md:hidden"
          v-if="offersList - 1 > index"></div>
    </template>
  </div>
</template>

<script setup>
import Product from "@/components/product/offers/Product";
import Empty from "@/components/product/offers/Empty";

const props = defineProps({
  offer: {
    type: Object,
    default: {}
  },
  offersList: {
    type: Number,
  },
  index: {
    type: Number,
  },
});


// All buy data
const itemsAddedToBuy = computed(() => props?.offer?.buy?.filter(({is_added_to_cart}) => is_added_to_cart))
const itemsNotAddedToBuy = computed(() => props?.offer?.buy?.filter(({is_added_to_cart}) => !is_added_to_cart))


// All get data
const itemsAddedToGet = computed(() => props?.offer?.get?.filter(({is_added_to_cart}) => is_added_to_cart))
const itemsNotAddedToGet = computed(() => props?.offer?.get?.filter(({is_added_to_cart}) => !is_added_to_cart))


const isAllAddedToBuy = computed(() => props?.offer?.buy?.every(({is_added_to_cart}) => is_added_to_cart))
</script>